import styled from 'styled-components';
import CloseIcon from '@material-ui/icons/Close';

const Container = styled.div`
  min-height: 100vh;
  height: auto;
  width: 100vw;
  max-width: 100%;
  transition: all ease-out 0.25s;
  position: relative;
  padding: 12px;
  background: #ffffff;
  background-clip: padding-box;
  box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.25);
  @media (min-width: 768px) {
    width: 70vw;
  }
`;
const Header = styled.div`
  position: relative;
  h2 {
    font-size: 24px;
    font-weight: 100;
  }
`;
const CloseIconStyle = styled(CloseIcon)`
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
`;
const SearchWrapper = styled.div`
  display: flex;
  grid-gap: 15px;
  margin-bottom: 25px;
`;
const ArtworksLibrary = styled.div`
  margin-top: 20px;
  min-height: 150px;
  max-height: 80vh;
  overflow-y: auto;
  > div {
    display: grid;
    align-items: start;
    transition: all ease-out 0.25s;
    column-gap: 20px;
    row-gap: 20px;
    grid-template-columns: repeat(2, 1fr);
    @media (min-width: 768px) {
      grid-template-columns: repeat(4, 1fr);
    }
    @media (min-width: 1100px) {
      grid-template-columns: repeat(6, 1fr);
    }
  }
`;

const Procedure = styled.span`
  color: #000;
  text-decoration: underline;
  cursor: pointer;
`;

const ShirtlyCharges = styled.span`
  color: #000;
  float: right;
`;

const Support = styled.a`
  color: #000;
  text-decoration: underline;
  cursor: pointer;
`;

const FontPickerWrapper = styled.div`
  width: 100%;
  #font-picker {
    width: 100%;
    border: 1px solid #ccc;
    box-shadow: none;
    border-radius: 5px;
    & > button {
      background: transparent;
      height: 55px;
      font-size: 20px;
    }
    & > ul {
      z-index: 9;
      background: white;
      top: 58px;
      overflow: auto;
      li {
        height: auto;
        border-bottom: 1px solid #ccc;
        font-size: 22px;

        button {
          padding: 10px;
        }
      }
    }
  }
`;

const HexColorPickerWrapper = styled.div`
  margin: 30px 0px;
  .react-colorful {
    display: block;
    margin: 0 auto;
    .react-colorful__saturation {
      height: 185px;
    }
  }
`;

export {
  Container,
  Header,
  CloseIconStyle,
  SearchWrapper,
  ArtworksLibrary,
  Procedure,
  Support,
  ShirtlyCharges,
  FontPickerWrapper,
  HexColorPickerWrapper,
};
